import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-public-layout',
  imports: [RouterOutlet],
  templateUrl: './public-layout.component.html',
  host: { class: 'flex flex-col h-screen bg-neutral-100 overflow-y-auto' }
})
export class PublicLayoutComponent {}
